
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/requests",
      function () {
        return require("private-next-pages/me/requests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/requests"])
      });
    }
  